import React from "react";

/*
 * HCC logo — exact client asset with its white surround made transparent
 * computationally (scripts/logo_transparent.py). The artwork itself is never
 * redrawn, recoloured or cropped. `onDark` adds a restrained CSS glow
 * (presentation only) so the navy letterforms stay legible on charcoal.
 */
export const Logo = ({ width = 120, onDark = false, className = "", testId = "hcc-logo" }) => (
  <span className={`block ${className}`} style={{ width, aspectRatio: "472 / 159" }}>
    <img
      src="/hcc-logo.png"
      alt="Hema Connoisseur Collections"
      data-testid={testId}
      className={`block h-full w-full object-contain select-none ${
        onDark
          ? "[filter:drop-shadow(0_0_1px_rgba(247,241,231,0.6))_drop-shadow(0_0_14px_rgba(247,241,231,0.32))]"
          : ""
      }`}
      draggable="false"
    />
  </span>
);
